import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const VsimProductsList = ({ vsimProducts, handleChangeVsim }) => {
  return (
    <table className={cn('table', styles.table)}>
      <thead>
        <tr>
          <th>Product Id</th>
          <th>Product Name</th>
          <th>Carrier</th>
          <th>Channel</th>
          <th>Unused vSIM</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {vsimProducts?.map(
          ({
            sim_product_id,
            sim_product_name,
            carrier,
            channel,
            unused_vsim,
          }) => (
            <tr key={sim_product_id}>
              <td>{sim_product_id}</td>
              <td>{sim_product_name}</td>
              <td>{carrier}</td>
              <td>{channel}</td>
              <td>{unused_vsim}</td>
              <td>
                <button
                  className="btn btn-primary"
                  onClick={() => handleChangeVsim(sim_product_id)}
                >
                  Change
                </button>
              </td>
            </tr>
          ),
        )}
      </tbody>
    </table>
  );
};

export default VsimProductsList;
